import React, { useContext, useMemo } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { DeleteOutlined, Star, StarOutline, VisibilityOutlined } from '@mui/icons-material';
import { ModalsContext } from '../../contexts/ModalsContext';
import { AuthContext } from '../../contexts/AuthContext';
import { convertirLetraMayus } from '../../helpers/convertirLetraMayus';
import { DeleteTurnForm } from './DeleteTurnForm';
import { encontrarModulo } from '../../helpers/encontrarModulo';
import { useModalStore } from '../../store/useModalStore';

export const Actions = ({ data, priority, deleted }) => {

    const { usuario: { rol: { nombre: rol }, permisos } } = useContext(AuthContext);
    // const { modalRef: { current: { handleOpen } } } = useContext(ModalsContext);
    const { openModal } = useModalStore();


    const actions = useMemo(() => {
        return encontrarModulo(permisos, data?.sede?.nombre, 'sedes')?.actions?.map(a => (rol?.includes('admin') || a?.active) ? a : null);
    }, []);

    // const openModal = (form) => handleOpen(form);

    const buttons = [
        { icon: data?.prioritario
            ? <Star htmlColor='#fbc02d' fontSize='small' />
            : <StarOutline color='action' fontSize='small' />, action: () => priority(data?.uid, data?.prioritario) },
        { icon: <VisibilityOutlined color='action' fontSize='small' />, action: () => false },
        { icon: <DeleteOutlined color='action' fontSize='small' />, action: () => openModal(<DeleteTurnForm action={ (e) => deleted({ ...e, data }) } />) }
    ];

    return (
        <>
            { actions?.map((a, i) => a && (
                <Tooltip title={ convertirLetraMayus(a?.name) }>
                    <IconButton aria-label="read" onClick={ buttons[i]?.action }>
                        { buttons[i]?.icon }
                    </IconButton>
                </Tooltip>
            ))}
        </>
    );
}